import React from 'react';
import axios from 'helpers/axios';

import { Form, Container, Title, TextInput, Button, Label } from 'ui/components/styled';
import { ValidationPattern } from 'helpers/form';
import { useToasts } from 'hooks';

export const EditCategory = ({ category, onClose, onSuccess }) => {
  const [state, setState] = React.useState({ name: category?.name });
  const [preventSubmit, setPreventSubmit] = React.useState(false);
  const { errorToast, successToast, removeAllToasts } = useToasts();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((state) => ({ ...state, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setPreventSubmit(true);
      const response = await axios.put(`/jobs/categories/${category?.id}`, state);
      if (response.status === 200) {
        removeAllToasts();
        successToast('Category updated successfully!');
        if (onClose) {
          onClose();
        }
        if (onSuccess) {
          onSuccess();
        }
        return;
      }
    } catch (error) {
      errorToast({ error, default: 'Error: Edit Category.' });
    }
    setPreventSubmit(false);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Container mb="xs">
        <Title variant="darkGrey" fontWeight="500">
          Edit category
        </Title>
      </Container>
      <Container mb="m">
        <Label htmlFor="name" mb="xs">
          Category name
        </Label>
        <TextInput
          id="name"
          name="name"
          variant="minimal"
          placeholder="Category name"
          value={state.name}
          onChange={handleChange}
          pattern={ValidationPattern.extendedAlphanumeric}
          title="Please enter a valid category name"
          required
          autoFocus
        />
      </Container>
      <Container flexDirection="row" justifyContent="flex-end" mt="xxs">
        <Button
          variant="contrast-primary"
          width="30%"
          disabled={preventSubmit}
          onClick={onClose}
          boxShadow="none"
          mr="s"
        >
          Close
        </Button>
        <Button type="submit" width="35%" disabled={preventSubmit}>
          Update Category
        </Button>
      </Container>
    </Form>
  );
};
